module.exports = __webpack_public_path__ + "static/media/cafe_popular.cbfd5039.jpg";